import { Component } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Vehicle } from 'src/app/Models/vehicle';
import { MatDialogRef } from '@angular/material';
import { MessageService } from '../../../core/services/message.service';

@Component({
    selector: 'dialog-optimize',
    templateUrl: './dialog-optimize.component.html',
    styleUrls: ['./dialog-optimize.component.scss']
})

export class DialogOptimizeComponent {
    
  vehicles: Vehicle[] = [];
  selectedVehicles: Vehicle[] = [];
    constructor(private apiService: ApiService, private dialogRef: MatDialogRef<DialogOptimizeComponent>,
      private messageService: MessageService) {
      this.getVehicles();
    }

getVehicles() {
    this.apiService.get('api/vehicle/findAll').subscribe((response: any) => {
      if (response.data) {
        this.vehicles = response.data;
      }
    });
  }

  moveShip(){
    if(this.selectedVehicles.length == 0){
      this.messageService.warning('Error', 'Debe seleccionar un vehiculo.');
      return;
    }
    this.dialogRef.close(this.selectedVehicles);
  }

  
}
